<template>
  <v-select
    v-model="localValue"
    class="mt-6"
    label="For"
    outlined
    hide-details
    dense
    :items="repositories"
    :rules="[rules.required]"
    item-text="name"
    item-value="value"
    return-object
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
  import ObjectValue from '@/components/form/mixins/objectValue'
  import RequiredRules from '@/components/form/mixins/required'
  export default {
    name: 'FormRepoSelect',
    mixins: [ObjectValue, RequiredRules],
    data () {
      return {
        repositories: [
          {
            name: 'Vuetify',
            value: 'vuetify',
            url: '/vuetifyjs/vuetify',
          },
          {
            name: 'Vuetify Documentation',
            value: 'docs',
            url: '/vuetifyjs/vuetify',
          },
        ],
      }
    },
    created () {
      this.localValue = this.repositories.find(repo => repo.value === 'vuetify')
    },
  }
</script>

<style lang="scss" scoped>

</style>
